import { Link } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { PageTitle, card } from "@/components/admin/ui";
import { money } from "@/lib/format";

export default function AdminCustomers() {
  const { data } = useApi("/admin/customers");
  if (!data) return <p className="text-[14px] text-[#6B7280]">Loading…</p>;

  return (
    <div data-testid="admin-customers-page">
      <PageTitle title="Customers" />
      <p className="-mt-3 mb-5 text-[13px] text-[#6B7280]">Everyone who bought a pass. Earnings are shown after the {data.platform_fee_pct}% Dancerfloor fee.</p>
      <div className={`${card} overflow-hidden`} data-testid="customers-table">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-[13px]">
          <thead className="bg-[#F9FAFB] text-left text-[12px] text-[#6B7280]">
            <tr>
              <th className="px-4 py-2.5 font-medium">Customer</th>
              <th className="px-4 py-2.5 font-medium">Festival</th>
              <th className="px-4 py-2.5 font-medium text-center">Passes</th>
              <th className="px-4 py-2.5 font-medium text-right">Spent</th>
              <th className="px-4 py-2.5 font-medium text-right">{data.is_admin ? "Organizer earned" : "You earned"}</th>
              <th className="px-4 py-2.5 font-medium">Last purchase</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB]">
            {data.customers.map((c) => (
              <tr key={c.email} className="hover:bg-[#F9FAFB]" data-testid="customer-row">
                <td className="px-4 py-2.5 font-medium">
                  <Link to={`/admin/customers/${encodeURIComponent(c.email)}`} className="hover:underline" data-testid={`customer-link-${c.email}`}>
                    {c.email}
                  </Link>
                </td>
                <td className="px-4 py-2.5 text-[#6B7280]">{c.festivals.join(", ") || "—"}</td>
                <td className="px-4 py-2.5 text-center">{c.purchases}</td>
                <td className="px-4 py-2.5 text-right">{money(c.spent, c.currency)}</td>
                <td className="px-4 py-2.5 text-right font-semibold">{money(c.earnings, c.currency)}</td>
                <td className="px-4 py-2.5 whitespace-nowrap text-[#6B7280]">{c.last_purchase_at ? new Date(c.last_purchase_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {data.customers.length === 0 && (
              <tr>
                <td colSpan={6} className="px-4 py-10 text-center text-[#6B7280]" data-testid="customers-empty">
                  No customers yet. They appear here as soon as someone buys a pass.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
